import { render, staticRenderFns } from "./water-compare.vue?vue&type=template&id=0b15fb10&scoped=true"
import script from "./water-compare.vue?vue&type=script&lang=js"
export * from "./water-compare.vue?vue&type=script&lang=js"
import style0 from "./water-compare.vue?vue&type=style&index=0&id=0b15fb10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b15fb10",
  null
  
)

export default component.exports